<template>
    <div class="page">
        <div class="message-centre-page">
            <b-card class="message-center">
                <div class="d-flex" style="min-height: calc(100vh - 282px)">
                    <div
                        v-if="vehicle && (!is_mobile || $route.name === Routes.message)"
                        class="message-center__thread border"
                        :class="{ 'w-100': is_mobile && $route.name === Routes.message }"
                        >
                        <div class="p-3 message-center__thread__vehicle-info">
                            <basic-info :deal="messages.data[0].deal"/>
                        </div>
                        <div class="message-center__thread__messages border">
                            <transition-group tag="div" name="fade">
                                <div
                                    v-for="message in messages.data"
                                    :key="message.id"
                                    class="col-12 col-md-6 inbox pb-4"
                                    :class="{ 'ml-auto' : shouldAlignMessageToRight(message) }"
                                    >
                                    <div class="ml-3">
                                        <h5 class="mb-2">
                                            {{ message.subject }}
                                        </h5>
                                    </div>
                                    <div
                                        class="w-100 basic-details mx-1 p-3 rounded"
                                        :style="auth.user.id === message.created_by ? 'background-color: #15A9F0' : 'background-color: #f5f5f5'"
                                        >
                                        <div :style="auth.user.id === message.created_by ? 'color: #ffffff' : 'color: #5B626B'">
                                            <div
                                                class="relative"
                                                style="font-weight: 700;"
                                                >
                                                From:
                                                <template v-if="auth.user.id === message.created_by">
                                                    Me
                                                </template>
                                                <template v-else>
                                                    {{ message.creator.name }} - {{ message.creator.companies[0].name }}
                                                </template>
                                            </div>
                                            <div class="relative">
                                                To:
                                                <template v-if="auth.user.id === message.recipient_id">
                                                    Me
                                                </template>
                                                <template v-else-if="message.receiver">
                                                    {{ message.receiver.name }} - {{ message.receiver.companies[0].name }}
                                                </template>
                                            </div>
                                            <span :title="$options.filters.local_datetime(message.created_at)" v-b-tooltip.hover>
                                                <i class="mdi mdi-clock-outline"></i> {{ message.created_at | relative }}
                                            </span><br/>
                                        </div>
                                        <div
                                            class="form-group"
                                            v-if="message.meta.type !== MessageType.newMessage && message.model_type === ModelType.offer"
                                            >
                                            <label class="col-form-label">Price:</label>
                                            <span class="align-self-center">
                                                <template v-if="[MessageType.counterOffer].includes(message.meta.type)">
                                                    {{ message.meta.counter_offer.amount | currency }}
                                                </template>
                                                <template
                                                    v-else-if="[MessageType.counterOfferAccepted, MessageType.counterOfferDenied].includes(message.meta.type)">
                                                    {{ message.model.latest_counter_offer_info.amount | currency }}
                                                </template>
                                                <template v-else>
                                                    {{ message.model.amount | currency }}
                                                </template>
                                            </span>
                                        </div>
                                        <div
                                            class="mt-4"
                                            :style="auth.user.id === message.created_by ? 'color: #ffffff' : 'color: #5B626B'"
                                            >
                                            <div class="mt-2">
                                                {{ message.body }}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        v-if="[MessageType.holdRequestDenied].includes(message.meta.type)"
                                        class="col-12 mt-3"
                                        >
                                        <el-tag type="danger">Denied</el-tag>
                                    </div>
                                    <div
                                        v-if="[MessageType.holdRequestExpired].includes(message.meta.type)"
                                        class="col-12 mt-3"
                                        >
                                        <el-tag type="danger">Expired</el-tag>
                                    </div>
                                    <div
                                        v-if="[DealStatus.holdRequest.value, DealStatus.onHold.value].includes(message.deal.status)"
                                        class="col-12 mt-3"
                                        >
                                        <template v-if="canAcceptOrDenyHoldRequest(message)">
                                            <b-button
                                                size="lg"
                                                variant="primary"
                                                :disabled="accept_hold_form.busy"
                                                @click="acceptHold(message.deal)"
                                                >
                                                Accept Hold
                                            </b-button>
                                            <b-button
                                                size="lg"
                                                @click="denyHold(message.deal)"
                                                >
                                                Deny Hold
                                            </b-button>
                                        </template>
                                    </div>
                                </div>
                            </transition-group>
                        </div>
                        <div v-if="!isSold">
                            <b-input-group>
                                <el-input
                                    v-model="chat_form.body"
                                    type="textarea"
                                    placeholder="Type message"
                                    :rows="4"
                                    @keydown.native.enter="onEnter"
                                    :readonly="DealStatus.completed.value === vehicle.status"
                                    >
                                </el-input>
                                <b-input-group-prepend class="w-100 d-flex flex-column flex-sm-row align-items-center justify-content-between justify-sm-content-center pt-2">
                                    <div class="text-center text-sm-left order-2 order-sm-0">
                                        <i class="mdi mdi-alert-circle" />
                                        Foundri recommends you ask for CARFAX and Damage Reports
                                    </div>
                                    <b-button
                                        class="rounded mt-1 mt-sm-0 order-1 order-sm-0"
                                        variant="primary"
                                        :disabled="!canSend || chat_form.busy"
                                        @click="sendMessage()"
                                        >
                                        <i class="mdi mdi-send"></i>
                                        Send
                                    </b-button>
                                </b-input-group-prepend>
                            </b-input-group>
                        </div>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import Message from "@/models/message";
import ModelType from "@/constants/model-types";
import MessageType from "@/constants/message-types";
import Roles from "@/constants/roles";
import Routes from "@/constants/routes";
import { DealStatus } from "@/constants/deal-statuses";
import VehicleStatus from "@/constants/vehicle-statuses";
import auth from "@/mixins/auth";
import bootbox from "bootbox";
import BasicInfo from "@/components/main/vehicle/BasicInfo";
import AuthUtils from "@/utils/auth";

const message_include = [
    'model.vehicle.vehicleYear',
    'model.vehicle.vehicleMake',
    'model.vehicle.vehicleModel',
    'model.vehicle.vehicleTrim',
    'creator.companies',
    'model.creator',
    'receiver',
    'receiver.companies',
    'deal',
    'deal.buyer.companies',
    'deal.seller.companies',
    'deal.vehicle',
    'deal.vehicle.company',
    'vehicle.company',
    'vehicle.company.users',
    'vehicle.company.users.roles',
];

export default {
    mixins: [auth],
    components: {
        BasicInfo
    },
    beforeRouteEnter(to, from, next) {
        let deal_id = to.params.deal_id;
        let customer_id = to.params.customer_id;

        Promise.all([
            Message
                .custom('/web-api/message/thread')
                .params({
                    deal_id,
                    customer_id,
                    no_pagination: 1,
                })
                .include(message_include)
                .get()
        ])
            .then(responses => {
                next(vm => {
                    vm.setData(responses[0], deal_id, customer_id);
                })
            })
    },
    beforeRouteUpdate(to, from, next) {
        let deal_id = to.params.deal_id;
        let customer_id = to.params.customer_id;

        Promise.all([
            Message.where('deal_id', deal_id)
                .params({
                    customer_id,
                    no_pagination: 1,
                })
                .include(message_include)
                .get()
        ])
            .then(responses => {
                this.setData(responses[0], deal_id, customer_id);
                next()
            })
    },
    data() {
        return {
            ModelType,
            MessageType,
            Roles,
            Routes,
            DealStatus,
            VehicleStatus,
            vehicle: null,
            messages: {
                data: [],
                meta: null,
            },
            accepting_offer: null,
            accept_offer_form: new Form(),
            countering_offer: null,
            counter_offer_form: new Form(
                {
                    amount: null,
                },
                {
                    amount: 'required|numeric'
                }
            ),
            accepting_hold: null,
            accept_hold_form: new Form(),
            denying_hold: null,
            deny_hold_form: new Form(),
            chat_form: new Form(
                {
                    body: null,
                    deal_id: null,
                    receiver_id: null,
                },
                {
                    body: 'required|string'
                }
            ),
            intervalId: null,
            previousMessageCount: 0,
        }
    },
    computed: {
        canSend() {
            if (DealStatus.completed.value === this.vehicle.status) {
                return false
            }

            return !_.isEmpty(this.chat_form.body ? this.chat_form.body.trim() : '');
        },
        isSold() {
            if (!this.vehicle) {
                return false
            }
            return _.includes([DealStatus.sold.value, DealStatus.completed.value], this.vehicle.status)
        },
        isOnHold() {
            if (!this.vehicle) {
                return false
            }
            return this.vehicle.status === DealStatus.onHold.value
        }
    },
    mounted() {
        window.Bus.$emit('initUnreadMessages');
        this.startPolling();
    },
    beforeDestroy() {
        this.stopPolling();
    },
    methods: {
        updateMessages() {
            this.previousMessageCount = this.messages.data.length;
            let deal_id = this.$route.params.deal_id;
            let customer_id = this.$route.params.customer_id;

            Message
                .custom('/web-api/message/thread')
                .params({
                    deal_id,
                    customer_id,
                    no_pagination: 1,
                })
                .include(message_include)
                .get()
                .then(response => {
                    this.setData(response, deal_id, customer_id);
                })
        },
        setData(response, deal_id, customer_id) {
            this.messages.data = response;
            const { vehicle } = this.messages.data[0];

            this.vehicle = vehicle;
            this.chat_form.deal_id = deal_id;
            this.chat_form.receiver_id = customer_id;

            if (this.messages.data.length > this.previousMessageCount) {
                Vue.nextTick(() => {
                    this.scrollToBottom();
                })
            }
        },
        scrollToBottom() {
            let thread = $('.message-center__thread__messages');
            thread.scrollTop(thread.prop('scrollHeight'));
        },
        canAcceptOrDenyHoldRequest(message) {
            if (this.isSold || this.isOnHold) {
                return false
            }

            if (message.hold_expiry || message.deal.status !== DealStatus.holdRequest.value) {
                return false
            }

            if (message.meta.type === MessageType.newHoldRequest) {
                const hasDealerOrManagerRole = AuthUtils.hasDealerOrManagerRole();

                if (!hasDealerOrManagerRole && message.deal.seller_id !== this.auth.user.id) {
                    return false;
                }

                if (hasDealerOrManagerRole && this.auth.user.companies[0].id !== message.deal.vehicle.company_id) {
                    return false;
                }

                return true;
            }

            return false;
        },
        acceptHold(hold) {
            this.accepting_hold = hold;
            bootbox.confirm({
                title: 'Confirm Accept',
                centerVertical: true,
                message: 'Are you sure you want to accept hold request?',
                buttons: {
                    confirm: {
                        label: "Yes",
                    }
                },
                callback: (result) => {
                    if (!result) {
                        return;
                    }
                    App.post(`/web-api/deal/${this.accepting_hold.id}/hold-request/accept`, this.accept_hold_form)
                        .then(response => {
                            this.$notify.success({
                                message: 'Hold request has been accepted'
                            });
                            this.vehicle.status = VehicleStatus.onHold.value;
                            _.extend(this.accepting_hold, response.data);
                            this.updateMessages();
                        })
                },
            });
        },
        denyHold(hold) {
            bootbox.confirm({
                title: 'Confirm Deny',
                centerVertical: true,
                message: 'Are you sure to deny the hold?',
                buttons: {
                    confirm: {
                        label: "Yes",
                    }
                },
                callback: (result) => {
                    if (!result) {
                        return;
                    }
                    App.post(`/web-api/deal/${hold.id}/hold-request/deny`, this.deny_hold_form)
                        .then(response => {
                            this.$notify.success({
                                message: 'Hold request has been denied.'
                            });
                            _.extend(hold, response.data);
                            this.updateMessages();
                        })
                },
            });
        },
        sendMessage() {
            this.chat_form.validate()
                .then(() => {
                    App.post(`/web-api/message?include=${message_include.join(',')}`, this.chat_form)
                        .then(response => {
                            this.chat_form.body = null;
                            this.messages.data.push(response.data);
                            Vue.nextTick(() => {
                                this.scrollToBottom()
                            });
                        });
                })
        },
        onEnter(e) {
            if (!e.shiftKey) {
                e.preventDefault();
                this.sendMessage();
            }
        },
        shouldAlignMessageToRight(message) {
            if (this.auth.user.id !== message.created_by) {
                if (this.auth.user.companies[0].id === message.creator.companies[0].id) {
                    return true
                } else {
                    return false
                }
            }

            return this.auth.user.id === message.created_by;
        },
        startPolling() {
            this.intervalId = setInterval(this.updateMessages, 2000);
        },
        stopPolling() {
            clearInterval(this.intervalId);
            this.intervalId = null;
        },
    }
}
</script>
<style scoped>
.message-centre-page .message-center__thread {
    width: 100% !important;
}
</style>
